import * as ActionTypes from '../constants/action_types'
import * as utils from './utils'

// -----------------------------------------------------------------------------
// API Calls

function fetchTrendingTopicsTwitter (date) {
  const body = {
    date: date
  }
  return utils.makeApiCall({
    url: '/api/insights/trending-topics/twitter',
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_TRENDING_TOPICS_TWITTER,
    actionReceive: ActionTypes.RECEIVE_TRENDING_TOPICS_TWITTER,
    actionFailure: ActionTypes.REQUEST_TRENDING_TOPICS_TWITTER_FAILURE,
    authenticated: true,
    actionProps: {
      date: date
    }
  })
}

function fetchTrendingTopicsYoutube (date) {
  const body = {
    date: date
  }
  return utils.makeApiCall({
    url: '/api/insights/trending-topics/youtube',
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_TRENDING_TOPICS_YOUTUBE,
    actionReceive: ActionTypes.RECEIVE_TRENDING_TOPICS_YOUTUBE,
    actionFailure: ActionTypes.REQUEST_TRENDING_TOPICS_YOUTUBE_FAILURE,
    authenticated: true,
    actionProps: {
      date: date
    }
  })
}

function fetchTrendingTopicsTikTok (date) {
  const body = {
    date: date
  }
  return utils.makeApiCall({
    url: '/api/insights/trending-topics/tiktok',
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_TRENDING_TOPICS_TIKTOK,
    actionReceive: ActionTypes.RECEIVE_TRENDING_TOPICS_TIKTOK,
    actionFailure: ActionTypes.REQUEST_TRENDING_TOPICS_TIKTOK_FAILURE,
    authenticated: true,
    actionProps: {
      date: date
    }
  })
}

function fetchTrendingTopicsInstagram (date) {
  const body = {
    date: date
  }
  return utils.makeApiCall({
    url: '/api/insights/trending-topics/instagram',
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_TRENDING_TOPICS_INSTAGRAM,
    actionReceive: ActionTypes.RECEIVE_TRENDING_TOPICS_INSTAGRAM,
    actionFailure: ActionTypes.REQUEST_TRENDING_TOPICS_INSTAGRAM_FAILURE,
    authenticated: true,
    actionProps: {
      date: date
    }
  })
}

function fetchTrendingTopicsDate () {
  return utils.makeApiCall({
    url: '/api/insights/trending-topics/max-date/v1',
    actionRequest: ActionTypes.REQUEST_TRENDING_TOPICS_DATE,
    actionReceive: ActionTypes.RECEIVE_TRENDING_TOPICS_DATE,
    actionFailure: ActionTypes.REQUEST_TRENDING_TOPICS_DATE_FAILURE,
    authenticated: true
  })
}

// -----------------------------------------------------------------------------
// User invokable actions

export function fetchTrendingTopicsTwitterIfNeeded (date) {
  return (dispatch) => {
    return dispatch(fetchTrendingTopicsTwitter(date))
  }
}

export function fetchTrendingTopicsYoutubeIfNeeded (date) {
  return (dispatch) => {
    return dispatch(fetchTrendingTopicsYoutube(date))
  }
}

export function fetchTrendingTopicsTikTokIfNeeded (date) {
  return (dispatch) => {
    return dispatch(fetchTrendingTopicsTikTok(date))
  }
}

export function fetchTrendingTopicsInstagramIfNeeded (date) {
  return (dispatch) => {
    return dispatch(fetchTrendingTopicsInstagram(date))
  }
}

export function fetchTrendingTopicsDateIfNeeded () {
  return (dispatch) => {
    return dispatch(fetchTrendingTopicsDate())
  }
}

function fetchTrendingTopicsExport (date) {
  const body = {
    date: date
  }
  return utils.makeApiCall({
    url: '/api/insights/trending-topics/export',
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_TRENDING_TOPICS_EXPORT,
    actionReceive: ActionTypes.RECEIVE_TRENDING_TOPICS_EXPORT,
    actionFailure: ActionTypes.REQUEST_TRENDING_TOPICS_EXPORT_FAILURE,
    authenticated: true,
    actionProps: {
      date: date,
      filename: 'TrendingTopics.xlsx'
    }
  })
}

export function fetchTrendingTopicsExportIfNeeded (date) {
  return (dispatch) => {
    return dispatch(fetchTrendingTopicsExport(date))
  }
}

export function setSelectedTrendDate (date) {
  return {
    type: ActionTypes.SET_TRENDING_TOPICS_DATE,
    date
  }
}